(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('VideoTypeSearch', VideoTypeSearch);

    VideoTypeSearch.$inject = ['$resource'];

    function VideoTypeSearch($resource) {
        var resourceUrl =  'api/_search/video-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
